import { border, lodestarColors, motion, typography } from "@smartsheet/design-tokens";
import { color } from "@smartsheet/design-tokens-react";
import { themed } from "@smartsheet/sds-theme-internal";
export const radioBorderTheme = themed({
  disabled: {
    checked: {
      "lodestar-light": color("color--border--primary--weak"),
      "ursa-light": color("color--background--primary--weak")
    },
    unchecked: {
      "lodestar-light": color("color--border--neutral--weak"),
      "ursa-light": color("color--border--neutral--weakest")
    }
  },
  invalid: {
    rest: color("color--border--error--default"),
    hover: color("color--border--error--default"),
    active: color("color--border--error--default")
  },
  active: {
    unchecked: {
      "lodestar-light": color("color--border--spectrum-blue--default"),
      "ursa-light": color("color--border--primary--default")
    },
    checked: {
      "lodestar-light": color("color--border--spectrum-blue--default"),
      "ursa-light": color("color--background--primary--stronger")
    }
  },
  rest: {
    unchecked: {
      "lodestar-light": color("color--border--neutral--strong"),
      "ursa-light": color("color--border--neutral--default")
    },
    checked: {
      "lodestar-light": lodestarColors.buttonPrimary,
      // no semantic token
      "ursa-light": color("color--border--primary--default")
    }
  },
  hover: {
    unchecked: {
      "lodestar-light": color("color--border--neutral--strong"),
      "ursa-light": color("color--border--neutral--default")
    },
    checked: {
      "lodestar-light": lodestarColors.buttonPrimary,
      // no semantic token
      "ursa-light": color("color--border--primary--default")
    }
  }
});
export const radioInnerDotTheme = themed({
  opacity: {
    checked: {
      "lodestar-light": 0,
      "ursa-light": 1
    },
    unchecked: 0
  }
});
export const radioFocusTheme = themed({
  gap: {
    "lodestar-light": 2,
    "ursa-light": 1
  }
});
export const radioMotionTheme = themed({
  default: {
    "lodestar-light": "box-shadow 0.2s",
    "ursa-light": `background-color ${motion.animation.default}`
  },
  animation: {
    "lodestar-light": "",
    "ursa-light": `${motion.animation.default}`
  }
});
export const radioIconTheme = themed({
  backgroundColor: {
    rest: {
      "lodestar-light": color("color--background--surfaces--body"),
      "ursa-light": color("color--background--surfaces--work")
    },
    hover: {
      "lodestar-light": color("color--background--surfaces--body"),
      "ursa-light": color("color--background--neutral--weaker")
    },
    active: {
      "lodestar-light": color("color--background--surfaces--body"),
      "ursa-light": color("color--background--neutral--default")
    },
    checked: {
      "lodestar-light": color("color--background--surfaces--body"),
      "ursa-light": "transparent"
    }
  },
  borderWidth: {
    rest: {
      "lodestar-light": border.width20,
      "ursa-light": border.width10
    },
    hover: {
      "lodestar-light": "3px",
      "ursa-light": border.width10
    },
    checked: {
      large: {
        "lodestar-light": "6px",
        "ursa-light": border.width10
      },
      medium: {
        "lodestar-light": "4.5px",
        "ursa-light": border.width10
      }
    }
  },
  marginTop: {
    large: "0",
    medium: "1px"
  }
});
export const radioLabelTheme = themed({
  color: {
    disabled: {
      "lodestar-light": color("color--text--neutral--strong"),
      "ursa-light": color("color--text--neutral--weakest")
    },
    rest: "inherit"
  },
  gap: {
    "lodestar-light": "8px",
    "ursa-light": "6px"
  },
  marginTop: {
    large: "1px",
    medium: "0"
  },
  fontWeight: {
    checked: {
      "lodestar-light": typography.fontWeight.semiBold,
      "ursa-light": typography.fontWeight.medium
    },
    unchecked: typography.fontWeight.medium
  }
});
//# sourceMappingURL=radioTheme.js.map